export const askQuestionsPage = {
    stepMakeQuestion: {
        title: 'Ring hvis du har spørsmål - din telefonsamtale vil bli behandlet konfidensielt.',
        subtitleInfo1: 'Vennligst også sjekk våre ',
        faq: 'ofte stilte spørsmål',
        subtitleInfo2: ', der du kan finne svar på spørsmål om ',
        subtitleInfo3: 'varslerordningen',
    },
};
